import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import styled from 'styled-components';
import { ThemeModeProvider, useThemeMode } from './context/ThemeContext';

// Layout Components
import BottomNavigation from './components/Layout/BottomNavigation';
import MainHeader from './components/Layout/MainHeader';

// Pages
import Login from './pages/Login';
import Inicio from './pages/Inicio';
import Agenda from './pages/Agenda';
import Medicos from './pages/Medicos';
import Pacientes from './pages/Pacientes';
import Reportes from './pages/Reportes';
import PerfilMedico from './pages/PerfilMedico';
import PerfilPaciente from './pages/PerfilPaciente';
import ReservarCita from './pages/ReservarCita';
import RegistroPaciente from './pages/RegistroPaciente';
import DetalleCita from './pages/DetalleCita';
import GestionServicios from './pages/GestionServicios';
import BloquearHorarios from './pages/BloquearHorarios';
import Perfil from './pages/Perfil';
import GestionarAgenda from './pages/GestionarAgenda';
import GestionPersonal from './pages/GestionPersonal';
import ReporteCitas from './pages/ReporteCitas';
import ReporteIngresos from './pages/ReporteIngresos';
import GestionFormularios from './pages/GestionFormularios';
import EditorFormulario from './pages/EditorFormulario';
import VistaFormulario from './pages/VistaFormulario';
import SeleccionarFormulario from './pages/SeleccionarFormulario';
import SeleccionarFormularioNuevo from './pages/SeleccionarFormularioNuevo';
import LlenarFormulario from './pages/LlenarFormulario';
import VerFormularioCompletado from './pages/VerFormularioCompletado';
import GenerarRecibo from './pages/GenerarRecibo';
import Inventario from './pages/Inventario';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
`;

// Componente Layout que oculta header/navigation en login
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <AppContainer>
      {!isLoginPage && <MainHeader />}
      {children}
      {!isLoginPage && <BottomNavigation />}
    </AppContainer>
  );
};

// Componente interno que usa el contexto del tema
const AppContent = () => {
  const { theme } = useThemeMode();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <AppLayout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Inicio />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/medicos" element={<Medicos />} />
            <Route path="/pacientes" element={<Pacientes />} />
            <Route path="/reportes" element={<Reportes />} />
            <Route path="/perfil-medico/:id" element={<PerfilMedico />} />
            <Route path="/perfil-paciente/:id" element={<PerfilPaciente />} />
            <Route path="/reservar-cita" element={<ReservarCita />} />
            <Route path="/registro-paciente" element={<RegistroPaciente />} />
            <Route path="/detalle-cita/:id" element={<DetalleCita />} />
            <Route path="/gestion-servicios/:id" element={<GestionServicios />} />
            <Route path="/bloquear-horarios/:id" element={<BloquearHorarios />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/gestionar-agenda/:id" element={<GestionarAgenda />} />
            <Route path="/gestion-personal" element={<GestionPersonal />} />
            <Route path="/reporte-citas" element={<ReporteCitas />} />
            <Route path="/reporte-ingresos" element={<ReporteIngresos />} />
            <Route path="/gestion-formularios" element={<GestionFormularios />} />
            <Route path="/nuevo-formulario" element={<EditorFormulario />} />
            <Route path="/editar-formulario/:id" element={<EditorFormulario />} />
            <Route path="/vista-formulario/:id" element={<VistaFormulario />} />
            <Route path="/seleccionar-formulario/:patientId" element={<SeleccionarFormulario />} />
            <Route path="/seleccionar-formulario-nuevo" element={<SeleccionarFormularioNuevo />} />
            <Route path="/llenar-formulario/:formId/:patientId" element={<LlenarFormulario />} />
            <Route path="/ver-formulario/:formId/:patientId" element={<VerFormularioCompletado />} />
            <Route path="/generar-recibo/:citaId" element={<GenerarRecibo />} />
            <Route path="/inventario" element={<Inventario />} />
          </Routes>
        </AppLayout>
      </Router>
    </ThemeProvider>
  );
};

function App() {
  return (
    <ThemeModeProvider>
      <AppContent />
    </ThemeModeProvider>
  );
}

export default App;
